import { primitive } from 'styles/constants';
export default {
  changeLinkColor: primitive.$greyOne,
  phoneNumberInformationColor: primitive.$greyThree,
};
